/** Short looping clips shown inside a setup-guide phase, self-hosted under /frontend/public/media/sync/.
 *  A phase without an entry simply shows no clip, so a clip goes live by dropping the file in and adding
 *  its entry here. Prefer muted .mp4/.webm loops over .gif — the same 10 seconds is many times smaller.
 *  What each clip should show: info/Sync/praxis-software-sync-guide-recording.md. */
export type GuideClip = { src: string; poster?: string };

export type GuidePhaseKey = "prepare" | "install" | "connect" | "daily" | "connectBrowser" | "dailyBrowser";

export const SYNC_GUIDE_MEDIA: Partial<Record<GuidePhaseKey, GuideClip>> = {
    // install: { src: "/media/sync/install.mp4", poster: "/media/sync/install.jpg" },
};
